import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faArrowUp,
  faBars,
  faBarcode,
  faBell,
  faBookmark,
  faBug,
  faBuilding,
  faCalculator,
  faCamera,
  faCaretDown,
  faCaretSquareDown,
  faCaretSquareUp,
  faCaretUp,
  faCheck,
  faCheckSquare,
  faClinicMedical,
  faClone,
  faCog,
  faComment,
  faCommentAlt,
  faCopy,
  faCreditCard,
  faDesktop,
  faDollarSign,
  faDownload,
  faEdit,
  faEllipsisV,
  faExchangeAlt,
  faExclamationCircle,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileCsv,
  faFileCode,
  faFilePdf,
  faFileSignature,
  faFileUpload,
  faFilter,
  faFolderPlus,
  faHandPaper,
  faHandPointRight,
  faHeartbeat,
  faHome,
  faImage,
  faImages,
  faIndustry,
  faInfo,
  faInfoCircle,
  faListAlt,
  faListUl,
  faMinus,
  faMoneyBillWave,
  faPaperclip,
  faPhoneAlt,
  faPlay,
  faPause,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPrint,
  faQuestionCircle,
  faReply,
  faRedoAlt,
  faSave,
  faScrewdriver,
  faSearch,
  faSearchMinus,
  faSearchPlus,
  faSignOutAlt,
  faSitemap,
  faSpinner,
  faStore,
  faSync,
  faTimes,
  faTimesCircle,
  faTrash,
  faTrashAlt,
  faTruck,
  faTruckMoving,
  faUndo,
  faUser,
  faUserPlus,
  faUsers,
  faWrench,
  faChevronCircleDown,
  faChevronCircleUp,
  faCheckCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "./App.css";
import {
  AddOnBundleManagement,
  AdminLanding,
  BuildCertify,
  BuildDetails,
  Builds,
  CashSales,
  CompanyAddEdit,
  CompanyAdmin,
  ContractView,
  DocIndex,
  EditDocList,
  EditReportParameters,
  EditSubProduct,
  EditSignatureLocations,
  Home,
  InspectionDetailsManagement,
  Inspections,
  Inventory,
  InventorySales,
  InventoryEdit,
  InventoryView,
  Login,
  ManufacturerBuilders,
  ManufacturerBuildSteps,
  ManufacturerColors,
  ManufacturerCompanies,
  ManufacturerSubProducts,
  ManufacturerUnitTypes,
  MfgAdmin,
  PasswordReset,
  Quotes,
  QuoteView,
  ReportList,
  ReportParameters,
  ReportsIndex,
  RTOContracts,
  SignatureCapture,
  StoreAdmin,
  SubProductSKU,
  TemplateManagement,
  UserAddEdit,
  UserAdmin,
  UserProfile,
  Companies,
  Manufacturers,
  PrivacyPolicy,
  Stores,
  ManufacturerAddOns,
  ManufacturerSettings,
  ManufacturerStores,
  TaxRates,
  RTOProTaxZones,
  Regions,
  ManufacturerUsers,
} from "./components";
import { ContractEdit } from "./components/contractedit";
import { ThankYou } from "./pos-signature-module/signature-capture/components";
import { api, constants } from "./utils"; // UserContext
import { default as useUserStore } from "./hooks/useUserStore";
library.add(
  faIndustry,
  faStore,
  faReply,
  faTruckMoving,
  faUsers,
  faExchangeAlt,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faArrowsAlt,
  faArrowUp,
  faBars,
  faBarcode,
  faBell,
  faBuilding,
  faCalculator,
  faCaretDown,
  faCaretSquareDown,
  faCaretSquareUp,
  faCaretUp,
  faCheck,
  faCog,
  faComment,
  faCreditCard,
  faDesktop,
  faDollarSign,
  faEdit,
  faEllipsisV,
  faExternalLinkAlt,
  faEye,
  faEyeSlash,
  faFileCsv,
  faFileCode,
  faFileSignature,
  faFileUpload,
  faFilter,
  faFolderPlus,
  faHandPaper,
  faHandPointRight,
  faHeartbeat,
  faHome,
  faImage,
  faInfo,
  faInfoCircle,
  faListAlt,
  faListUl,
  faMoneyBillWave,
  faPaperclip,
  faPhoneAlt,
  faPlay,
  faPause,
  faPlug,
  faPlus,
  faPlusCircle,
  faPlusSquare,
  faPrint,
  faRedoAlt,
  faSave,
  faScrewdriver,
  faSearch,
  faSearchMinus,
  faSearchPlus,
  faSignOutAlt,
  faSitemap,
  faSync,
  faTimes,
  faTimesCircle,
  faTrashAlt,
  faTruck,
  faUndo,
  faUser,
  faUserPlus,
  faWrench,
  faImages,
  faFilePdf,
  faMinus,
  faCommentAlt,
  faClone,
  faBug,
  faFileUpload,
  faDownload,
  faCheckSquare,
  faExclamationCircle,
  faBookmark,
  faCopy,
  faClinicMedical,
  faSpinner,
  faCamera,
  faQuestionCircle,
  faTrash,
  faChevronCircleDown,
  faChevronCircleUp,
  faCheckCircle
);

const { ICONS } = constants;
const PATHNAMES = constants.PATH_NAMES;

function App() {
  const [loading, setLoading] = useState(true);
  // const history = useHistory();
  const currentUser = useUserStore((x) => x.currentUser);
  // const setCurrentUser = useUserStore(x => x.setCurrentUser);

  useEffect(() => {
    Promise.all([
      api.getCachedImage(ICONS.contract),
      api.getCachedImage(ICONS.delivery),
      api.getCachedImage(ICONS.landlord),
      api.getCachedImage(ICONS.payment),
      api.getCachedImage(ICONS.logo),
    ])
      .then((results) => {
        // console.log('results preloading images completed')
      })
      .catch(api.catchHandler)
      .finally(() => setLoading(false));
  }, []);

  const AuthRoute = (props) => {
    if (!currentUser) return <Redirect to={PATHNAMES.LOGIN} />;
    return <Route {...props} />;
  };

  if (loading) return <div />;

  return (
    <Switch>
      <Route exact path={PATHNAMES.PRIVACY_POLICY_MOBILE_APP} component={PrivacyPolicy} />
      <Route exact path={PATHNAMES.LOGIN} component={Login} />
      <Route exact path={PATHNAMES.FORGOT_PASSWORD} component={PasswordReset} />
      <Route exact path={`${PATHNAMES.SIGNATURE}/:code?/:isMobile?`} component={SignatureCapture} />
      <Route exact path={PATHNAMES.THANK_YOU} component={ThankYou} />
      <AuthRoute exact path={PATHNAMES.HOME} component={Home} />
      <AuthRoute exact path={PATHNAMES.BUILDS} component={Builds} />
      <AuthRoute
        exact
        path={PATHNAMES.INSPECTION_DETAILS_MANAGEMENT}
        component={InspectionDetailsManagement}
      />
      <AuthRoute exact path={`${PATHNAMES.BUILD_DETAILS}/:id`} component={BuildDetails} />
      <AuthRoute exact path={PATHNAMES.TEMPLATE_MANAGEMENT} component={TemplateManagement} />
      <AuthRoute exact path={PATHNAMES.BUILD_CERTIFY} component={BuildCertify} />
      <AuthRoute exact path={PATHNAMES.INSPECTIONS} component={Inspections} />
      <AuthRoute exact path={PATHNAMES.RTOS} component={RTOContracts} />
      <AuthRoute exact path={PATHNAMES.CASH_SALES} component={CashSales} />
      <AuthRoute exact path={PATHNAMES.INVENTORY} component={Inventory} />
      <AuthRoute exact path={PATHNAMES.INVENTORY_SALES} component={InventorySales} />
      <AuthRoute exact path={PATHNAMES.QUOTES} component={Quotes} />
      <AuthRoute
        exact
        path={"/admin/manufacturer/:mfgId/:subProductId/skus/:activeTabIndex?"}
        component={SubProductSKU}
      />
      <AuthRoute
        exact
        path={"/admin/manufacturer/:mfgId/:subProductId/edit"}
        component={EditSubProduct}
      />
      <AuthRoute exact path={`${PATHNAMES.INVENTORY_VIEW}/:id`} component={InventoryView} />
      <AuthRoute exact path={PATHNAMES.NEW_QUOTE}>
        <ContractEdit contractType={constants.CONTRACT_TYPE.QUOTE} />
      </AuthRoute>
      <AuthRoute exact path={PATHNAMES.NEW_RTO}>
        <ContractEdit contractType={constants.CONTRACT_TYPE.RTO} />
      </AuthRoute>
      <AuthRoute
        exact
        path={`${PATHNAMES.QUOTE_EDIT}/:routeContractId/:fromInventoryId?`}
        render={(props) => <ContractEdit {...props} contractType={constants.CONTRACT_TYPE.QUOTE} />}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.CONVERT_QUOTE_TO_CASH_SALE}/:routeContractId`}
        render={(props) => (
          <ContractEdit
            {...props}
            contractType={constants.CONTRACT_TYPE.CASH_SALE}
            convertFromQuote={true}
          />
        )}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.CONVERT_QUOTE_TO_RTO}/:routeContractId`}
        render={(props) => (
          <ContractEdit
            {...props}
            contractType={constants.CONTRACT_TYPE.RTO}
            convertFromQuote={true}
          />
        )}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.NEW_QUOTE_VERSION}/:routeContractId`}
        render={(props) => <ContractEdit {...props} contractType={constants.CONTRACT_TYPE.QUOTE} />}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.CASH_SALE_EDIT}/:routeContractId`}
        render={(props) => (
          <ContractEdit {...props} contractType={constants.CONTRACT_TYPE.CASH_SALE} />
        )}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.CONTRACT_EDIT}/:routeContractId`}
        render={(props) => <ContractEdit {...props} contractType={constants.CONTRACT_TYPE.RTO} />}
      />
      <AuthRoute exact path={PATHNAMES.NEW_CASH_SALE}>
        <ContractEdit contractType={constants.CONTRACT_TYPE.CASH_SALE} />
      </AuthRoute>
      <AuthRoute
        exact
        path={PATHNAMES.QUOTE_VIEW + "/:routeContractId/:routeTabId?"}
        render={(props) => <QuoteView {...props} contractType={constants.CONTRACT_TYPE.QUOTE} />}
      />
      <AuthRoute
        exact
        path={PATHNAMES.CASH_SALE_VIEW + "/:routeContractId/:routeTabId?"}
        render={(props) => (
          <ContractView {...props} contractType={constants.CONTRACT_TYPE.CASH_SALE} />
        )}
      />
      <AuthRoute
        exact
        path={PATHNAMES.CONTRACT_VIEW + "/:routeContractId/:routeTabId?"}
        render={(props) => <ContractView {...props} contractType={constants.CONTRACT_TYPE.RTO} />}
      />
      <AuthRoute exact path={`${PATHNAMES.NEW_INVENTORY}/:inventoryId`} component={InventoryEdit} />
      <AuthRoute
        exact
        path={`${PATHNAMES.EDIT_INVENTORY}/:inventoryId`}
        component={InventoryEdit}
      />
      <AuthRoute exact path={PATHNAMES.USER_PROFILE} component={UserProfile} />
      <AuthRoute exact path={PATHNAMES.RESOURCES_DOCINDEX} component={DocIndex} />
      <AuthRoute exact path={PATHNAMES.RESOURCES_REPORTSINDEX} component={ReportsIndex} />
      <AuthRoute exact path={PATHNAMES.RESOURCES_EDITDOCLIST} component={EditDocList} />
      <AuthRoute exact path={PATHNAMES.RESOURCES_EDITREPORTDEF} component={ReportList} />
      <AuthRoute exact path="/Report/EditParameters/:reportId" component={EditReportParameters} />
      <AuthRoute exact path="/Report/:reportId/Parameters" component={ReportParameters} />
      <AuthRoute exact path={PATHNAMES.ADMIN} component={AdminLanding} />
      <AuthRoute exact path={PATHNAMES.COMPANY_ADMIN + "/:id/:tab?"} component={CompanyAdmin} />
      <AuthRoute exact path={PATHNAMES.ADMIN_COMPANIES} component={Companies} />
      <AuthRoute exact path="/admin/manufacturers" component={Manufacturers} />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/products"}
        component={ManufacturerSubProducts}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/unit-types"}
        component={ManufacturerUnitTypes}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/colors"}
        component={ManufacturerColors}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/companies"}
        component={ManufacturerCompanies}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/stores"}
        component={ManufacturerStores}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/users"}
        component={ManufacturerUsers}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/builders"}
        component={ManufacturerBuilders}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/colors"}
        component={ManufacturerColors}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/unit-types"}
        component={ManufacturerUnitTypes}
      />
      <AuthRoute
        exact
        path={PATHNAMES.ADMIN_SINGLE_MANUFACTURER + "/:mfgId/add-ons"}
        component={ManufacturerAddOns}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.ADMIN_SINGLE_MANUFACTURER}/:mfgId/bundles`}
        component={AddOnBundleManagement}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.ADMIN_SINGLE_MANUFACTURER}/:mfgId/build-steps`}
        component={ManufacturerBuildSteps}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.ADMIN_SINGLE_MANUFACTURER}/:id/settings`}
        component={ManufacturerSettings}
      />
      <AuthRoute
        exact
        path={`${PATHNAMES.ADMIN_SINGLE_MANUFACTURER}/:mfgId/inspections`}
        component={InspectionDetailsManagement}
      />
      <AuthRoute exact path="/admin/stores" component={Stores} />
      <AuthRoute exact path="/admin/taxrates" component={TaxRates} />
      <AuthRoute exact path="/admin/rtoprotaxzones" component={RTOProTaxZones} />
      <AuthRoute exact path="/admin/regions" component={Regions} />
      <AuthRoute exact path="/admin/manufacturer/:id" component={MfgAdmin} />
      <AuthRoute exact path={`/admin/store/:id`} component={StoreAdmin} />
      <AuthRoute exact path="/admin/users" component={UserAdmin} />
      <AuthRoute path="/company_add_edit" component={CompanyAddEdit} />
      <AuthRoute path="/user/:edit_user_id?" component={UserAddEdit} />
      <AuthRoute exact path="/edit-signature-locations/:id" component={EditSignatureLocations} />
      <AuthRoute
        exact
        path="/edit-default-signature-locations/:regionId/:cultureId"
        component={EditSignatureLocations}
      />
    </Switch>
  );
}

export default App;
